module.exports = __webpack_public_path__ + "static/img/图层56.dd32444b.png";